import { Injectable } from '@angular/core';
import { Licencia } from './../../models/licencia';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import 'rxjs/add/operator/map';

@Injectable({
  providedIn: 'root'
})
export class ListalicenciasService {

constructor(public http: HttpClient) {
  console.log ('serivicio de listado de lciencias accionado');
}





getLicencias() {
  const url = URL_SERVICIOS + '/costolicencias';
  return this.http.get ( url )
  .map ( (resp: any) => resp.licencia);

}


getLicenciaspagina() {
  const url = URL_SERVICIOS + '/costolicencias/listaprecioslic';
  return this.http.get ( url )
  .map ( (resp: any) => resp.licencia);

}

}
